import React from "react";
import {
  Flex,
  Spacer,
  Box,
  Button,
  Menu,
  MenuButton,
  MenuList,
  IconButton,
  useDisclosure,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  MenuItem,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { ImCross } from "react-icons/im";
import { useMediaQuery } from "@chakra-ui/media-query";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link } from "react-router-dom";
const Header = ({ setOpen, setOpen1 }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [placement, setPlacement] = React.useState("right");
  const [isnotSmallScreen] = useMediaQuery("(min-width:600px)");
  const { userWalletAddress } = useSelector((state) => state.UserReducer);
  return (
    <React.Fragment>
      <Box pb={2} borderBottom={"2px"} borderColor="#00B7C5">
        <Flex w="100%" pt={4} px={20} padding={!isnotSmallScreen ? "1rem" : ""}>
          {/* <VisuallyHidden

    
          > */}

          <Menu>
            <MenuButton
              display={{ base: "flex", md: "none" }}
              width={[
                "10%", // base
                "10%", // 480px upwards
                "50%", // 768px upwards
                "1rem", // 992px upwards
              ]}
              // margin=".1rem"
              as={IconButton}
              aria-label="Options"
              icon={<GiHamburgerMenu />}
              variant="outline"
              onClick={onOpen}
            />
          </Menu>
          {/* </VisuallyHidden> */}

          {/* <Menu>
            <IconButton
              display={{
                sm: "black",
                md: "none",
              }}
            >
              <GiHamburgerMenu />
            </IconButton> */}
          {/* </Menu> */}
          <Box display={{ base: "none", md: "block" }}>
            <Link className="Link" to="/">
              <Button
                color="black"
                bg="white"
                mx={3}
                _hover={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
                _focus={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
                _active={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
              >
                Home
              </Button>
            </Link>
            <Link className="Link" to="/create-sale">
              <Button
                color="black"
                bg="white"
                mx={3}
                _hover={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
                _focus={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
                _active={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
              >
                Create Sale
              </Button>
            </Link>
            <Link className="Link" to="/upcoming-sale">
              <Button
                color="black"
                bg="white"
                mx={3}
                _hover={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
                _focus={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
                _active={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
              >
                Upcoming Sales
              </Button>
            </Link>
            <Link className="Link" to="/join-sale">
              <Button
                color="black"
                bg="white"
                mx={3}
                _hover={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
                _focus={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
                _active={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
              >
                Join Sale
              </Button>
            </Link>
            <Link className="Link" to="/close-sale">
              <Button
                color="black"
                bg="white"
                mx={3}
                _hover={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
                _focus={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
                _active={{
                  color: "#00B7C5",
                  bg: "white",
                  textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
              >
                Closed Sales
              </Button>
            </Link>
          </Box>
          <Spacer />

          <Box>
            {userWalletAddress ? (
              <Button
                bg="#00B7C5"
                color="white"
                width={[
                  "100%", // base
                  "100%", // 480px upwards
                  "50%", // 768px upwards
                  "15rem", // 992px upwards
                ]}
                onClick={() => setOpen1(true)}
              >
                {userWalletAddress.slice(0, 6) +
                  "..." +
                  userWalletAddress.slice(-4)}
              </Button>
            ) : (
              <Button
                bg="#00B7C5"
                color="white"
                width={[
                  "100%", // base
                  "100%", // 480px upwards
                  "50%", // 768px upwards
                  "15rem", // 992px upwards
                ]}
                onClick={() => setOpen(true)}
              >
                Connect
              </Button>
            )}
          </Box>
        </Flex>
      </Box>{" "}
      {/* <Button colorScheme="blue" onClick={onOpen}>
        Open
      </Button> */}
      <Drawer placement={placement} onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent bgColor="#00B7C5" width="80%">
          <DrawerHeader borderBottomWidth="1px">
            {" "}
            <ImCross color="white" cursor="pointer" onClick={onClose} />
          </DrawerHeader>
          <DrawerBody>
            <Menu>
              <MenuItem
                minH="40px"
                // marginTop="2rem"
                borderBottom="1px solid #EDFAFB"
                color="#ffff"
                _hover={{
                  color: "#00B7C5",
                  bg: "white",
                  // textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
                // backgroundColor="#EDFAFB"
              >
                Home
              </MenuItem>

              <MenuItem
                minH="40px"
                _hover={{
                  color: "#00B7C5",
                  bg: "white",
                  // textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
                // backgroundColor="#EDFAFB"
                borderBottom="1px solid #EDFAFB"
                color="#ffff"
              >
                {" "}
                Sale{" "}
              </MenuItem>
              <MenuItem
                minH="40px"
                borderBottom="1px solid #EDFAFB"
                color="#ffff"
                _hover={{
                  color: "#00B7C5",
                  bg: "white",
                  // textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
              >
                {" "}
                Join Sale{" "}
              </MenuItem>
              <MenuItem
                minH="40px"
                borderBottom="1px solid #EDFAFB"
                color="#ffff"
                _hover={{
                  color: "#00B7C5",
                  bg: "white",
                  // textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
              >
                {" "}
                Create Sale{" "}
              </MenuItem>
              <MenuItem
                minH="40px"
                borderBottom="1px solid #EDFAFB"
                color="#ffff"
                _hover={{
                  color: "#00B7C5",
                  bg: "white",
                  // textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
              >
                {" "}
                Claim Tokens{" "}
              </MenuItem>
              <MenuItem
                minH="40px"
                borderBottom="1px solid #EDFAFB"
                color="#ffff"
                _hover={{
                  color: "#00B7C5",
                  bg: "white",
                  // textDecoration: "underline",
                  textDecorationColor: "#00B7C5",
                  textDecorationLine: "under",
                  textUnderlineOffset: "6px",
                  fontWeight: "500",
                }}
              >
                {" "}
                Manage Sale
              </MenuItem>
            </Menu>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </React.Fragment>
  );
};

export default Header;
